import { Box3, MathUtils, PerspectiveCamera, Vector3, type Object3D } from 'three';

const cameraGeometry = {
    // Compute the camera position that frames the given selection while
    // preserving the camera's current orientation. Returns the new
    // world-space position — caller is responsible for applying it.
    fitCameraToSelection(camera: PerspectiveCamera, target: Vector3, selection: Object3D[], fitOffset: number = 1): Vector3 {
        const box = new Box3();
        for (let i = 0; i < selection.length; i += 1) {
            box.expandByObject(selection[i]);
        }
        const size = new Vector3();
        box.getSize(size);
        const maxSize = Math.max(size.x, size.y, size.z);
        const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360));
        const fitWidthDistance = fitHeightDistance / camera.aspect;
        const distance = fitOffset + Math.max(fitHeightDistance, fitWidthDistance);
        const direction = target.clone().sub(camera.position).normalize().multiplyScalar(distance);
        return target.clone().sub(direction);
    },

    sphericalFromCartesian(x: number, y: number, z: number): { phi: number; radius: number; theta: number } {
        const radius = Math.sqrt(x * x + y * y + z * z);
        if (radius === 0) {
            return { phi: 0, radius: 0, theta: 0 };
        }
        return {
            phi: Math.acos(MathUtils.clamp(y / radius, -1, 1)),
            radius,
            theta: Math.atan2(x, z),
        };
    },

    cartesianFromSpherical(radius: number, phi: number, theta: number): Vector3 {
        const sinPhiRadius = Math.sin(phi) * radius;
        return new Vector3(sinPhiRadius * Math.sin(theta), Math.cos(phi) * radius, sinPhiRadius * Math.cos(theta));
    },
};

export { cameraGeometry };
